// extracted by mini-css-extract-plugin
module.exports = {"BundleProductListSectionWrapper":"SelectedProductListUI_BundleProductListSectionWrapper__2x1cQ","fadeInOpacity":"SelectedProductListUI_fadeInOpacity__kFaY8"};